import React, { useEffect, useState } from "react";

import { FloatInput, FloatSelectObject } from "../Floating";
import { useDispatch, useSelector } from "react-redux";
import { getCoursesList } from "../../appRedux/actions/courses";
import { getPlatformsList } from "../../appRedux/actions/platforms";
import FloatSelectSingle from "../Floating/FloatSelectSingle";

function Filter({ initialFetchComplete }) {
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState("");
  const [platform, setPlatform] = useState([]);
  const [category, setCategory] = useState([]);
  const [affiliated, setAffiliated] = useState("all");

  const { queryInfo, courseFilters, setOldQueryInfo } = useSelector(
    (state) => ({
      queryInfo: state.courses.queryInfo,
      courseFilters: state.courses.courseFilters,
      setOldQueryInfo: state.courses.setOldQueryInfo,
    })
  );
  const dbPlatformList = useSelector((state) => state.platforms.platformList || []);

  const [categoriesList, setCategoriesList] = useState(courseFilters.category);
  const [modeList, setModeList] = useState(courseFilters.mode);
  const [platformList, setPlatformList] = useState(courseFilters.platform);
  const [affiliationList, setAffiliationList] = useState(
    courseFilters.affiliation
  );
  const [courseTypeList, setCourseTypeList] = useState(
    courseFilters.course_type
  );
  const [languageList, setLanguageList] = useState(courseFilters.language);
  const [ratingList, setRatingList] = useState(courseFilters.rating);
  const [levelList, setLevelList] = useState(courseFilters.level);

  useEffect(() => {
    dispatch(getPlatformsList({ page: 1, size: 100 }));
  }, [dispatch]);

  useEffect(() => {
    if (dbPlatformList && dbPlatformList.length > 0) {
      setPlatformList(dbPlatformList);
    } else {
      setPlatformList(courseFilters.platform);
    }
  }, [dbPlatformList, courseFilters.platform]);

  useEffect(() => {
    setCategoriesList(courseFilters.category);
    setModeList(courseFilters.mode);
    setAffiliationList(courseFilters.affiliation);
    setCourseTypeList(courseFilters.course_type);
    setLanguageList(courseFilters.language);
    setRatingList(courseFilters.rating);
    setLevelList(courseFilters.level);
  }, [courseFilters]);
  // useEffect(() => {
  //   if (setOldQueryInfo) {
  //     setSearchText(queryInfo.title ? queryInfo.title : "");
  //     setPlatform(queryInfo.merchant ? [queryInfo.merchant] : []);
  //     setCategory(queryInfo.category ? [queryInfo.category] : []);
  //   }
  // }, [queryInfo, setOldQueryInfo]);
  useEffect(() => {
    if (initialFetchComplete) {
      const paramsArray = [];
      const valuesArray = [];

      if (platform.length > 0) {
        paramsArray.push("merchants");
        valuesArray.push(platform.join("|"));
      }
      if (category.length > 0) {
        paramsArray.push("categories");
        valuesArray.push(category.join("|"));
      }
      if (affiliated === "Impact") {
        paramsArray.push("is_affiliated");
        valuesArray.push(true);
      } else if (affiliated === "Direct") {
        paramsArray.push("is_affiliated");
        valuesArray.push(false);
      }

      const timeout = setTimeout(() => {
        dispatch(
          getCoursesList({
            page: 1,
            size: queryInfo.size || 10,
            "sort-by": queryInfo["sort-by"] || "rating:desc",
            q: searchText === "" ? undefined : searchText,
            param: paramsArray.length > 0 ? paramsArray : undefined,
            value: valuesArray.length > 0 ? valuesArray : undefined,
          })
        );
      }, 500);
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [searchText, category, platform, affiliated]);

  return (
    <div className="row filter-row">
      <div className="col-sm-6 col-md-4 pb-2">
        <FloatInput
          label="Search Courses (Title, Tags, Categories...)"
          value={searchText}
          name="searchText"
          id="inputCustom"
          onChange={(e) => {
            setSearchText(e.target.value);
          }}
        />
      </div>
      <div className="col-sm-6 col-md-2  pb-2">
        <div className="form-group form-focus select-focus">
          <FloatSelectObject
            label="Platform"
            // placeholder="Email here please"
            value={platform}
            name="platform"
            id="inputCustom"
            tag2="name"
            onChange={(value) => {
              setPlatform(value);
            }}
            showSearch={true}
            options={platformList}
          />
        </div>
      </div>

      <div className="col-sm-6 col-md-2 pl-1 pr-1 pb-2">
        <div className="form-group form-focus select-focus">
          <FloatSelectObject
            label="Category"
            // placeholder="Email here please"
            value={category}
            name="category"
            id="inputCustom"
            tag2="name"
            showSearch={true}
            onChange={(value) => {
              setCategory(value);
            }}
            // showSearch={true}
            options={categoriesList}
          />
        </div>
      </div>
      {/* 1. All
2. Impact
3. Direct */}
      <div className="col-sm-6 col-md-2 pl-1 pr-1 pb-2">
        <div className="form-group form-focus select-focus">
          <FloatSelectSingle
            label="Affiliated"
            // placeholder="Email here please"
            value={affiliated}
            name="affiliated"
            id="inputCustom"
            tag2="name"
            // showSearch={true}
            onChange={(value) => {
              setAffiliated(value);
            }}
            options={[
              { code: "all", name: "All" },
              { code: "Impact", name: "Impact" },
              { code: "Direct", name: "Direct" },
            ]}
          />
        </div>
      </div>
      {/* <div className="col-sm-6 col-md-2 "></div> */}
      <div className="col-sm-6 col-md-2 ">
        <button
          className="btn btn-success btn-block full-width w-100"
          onClick={() => {
            setSearchText("");
            setCategory([]);
            setPlatform([]);
            setAffiliated("all");
          }}
        >
          Clear
        </button>
      </div>
    </div>
  );
}

Filter.propTypes = {};

export default Filter;
